export default __webpack_public_path__ + "static/media/bystander-caption.f1e6b09d.jpeg";